import { TransactionManagement } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for transaction management in the admin section.
 * @returns {Array} An array containing the route objects for transaction management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.TRANSACTION_MANAGEMENT.path, // URL path for transaction management
      name: "Transaction Histroy", // Display name for the route
      key: adminRouteMap.TRANSACTION_MANAGEMENT.path, // Unique key for the route
      private: true, // Requires authentication to access
      belongsToSidebar: true, // Appears in the admin sidebar
      icon: adminRouteMap.TRANSACTION_MANAGEMENT.icon, // Icon associated with transaction management
      element: <TransactionManagement />, // Component to render for transaction management route
    },
  ];
}
